var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icon_Dashboard",
    transform: "translate(-5.102 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36219",
    "data-name": "Path 36219",
    d: "M5.1,5V24h19V5Zm18.156.844v7.664H5.946V5.844ZM5.946,14.352H17.557v8.8H5.946Zm12.456,8.8v-8.8h4.856v8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36220",
    "data-name": "Path 36220",
    d: "M18.356,56.2a2.631,2.631,0,0,0-1.6.929l-2.069-1.2A4.833,4.833,0,0,1,18.335,53.8V56.2ZM23,56.457l-2.09,1.2a2.368,2.368,0,0,1,0,1.857L23,60.72a4.808,4.808,0,0,0,.506-2.133A4.74,4.74,0,0,0,23,56.456Zm-6.5,1.2-2.09-1.2a4.744,4.744,0,0,0,0,4.265l2.09-1.2a2.278,2.278,0,0,1-.19-.929,2.6,2.6,0,0,1,.19-.93Zm3.779-.929c.042-.063.063-.148.106-.211,0-.021.021-.042.021-.063.084-.19.169-.38.253-.549,0-.021.021-.021.021-.042.042-.084.063-.148.106-.233a.071.071,0,0,1,.021-.042c.042-.084.084-.19.127-.275a2.545,2.545,0,0,1,.106-.233.071.071,0,0,1,.021-.042,1.392,1.392,0,0,0,.084-.211v-.021a1,1,0,0,0,.084-.233v-.021c.127-.317.233-.57.275-.717-.106.127-.253.338-.464.612l-.021.021a12327.564,12327.564,0,0,1-.3.379c-.021.021-.021.042-.042.042-.042.063-.084.127-.127.19,0,.021-.021.021-.021.042-.063.084-.106.148-.169.233,0,.021-.021.021-.021.042-.042.063-.084.127-.127.19-.021.021-.042.042-.042.063-.127.169-.233.317-.359.486-.021.021-.021.042-.042.042-.042.063-.084.127-.127.19-.021-.039-.021-.018-.043,0-.717.971-1.351,1.879-1.436,2.006a.6.6,0,0,0,1.034.612c.084-.127.549-1.119,1.034-2.217.022-.021.022-.042.044-.042Zm1.14-2.111c-.253.633-.633,1.478-.992,2.28a2.114,2.114,0,0,1,.19.233l2.069-1.2a5.326,5.326,0,0,0-1.267-1.31Zm-.528-.317a4.886,4.886,0,0,0-1.9-.506V56.2a2.552,2.552,0,0,1,.422.084c.528-.7,1.077-1.435,1.478-1.984Z",
    transform: "translate(-6.943 -38.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36221",
    "data-name": "Path 36221",
    d: "M14.767,19.068H13.5v-5h1.267ZM16.772,13.2H15.506v5.869h1.267Zm2.006,2.639H17.511v3.23h1.267Zm2.006-.992H19.517v4.222h1.267Zm2.006-.781H21.522v5h1.267Zm2.006,1.773H23.528v3.23h1.267ZM26.8,17.189H25.533v1.879H26.8Zm2.006-.655H27.539v2.533h1.267Z",
    transform: "translate(-6.625 -6.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36222",
    "data-name": "Path 36222",
    d: "M71,53.5h3.589v1.034H71Z",
    transform: "translate(-51.987 -38.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36223",
    "data-name": "Path 36223",
    d: "M71,63.2h2.7v1.034H71Z",
    transform: "translate(-51.987 -45.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36224",
    "data-name": "Path 36224",
    d: "M71,72.5h1.921v1.034H71Z",
    transform: "translate(-51.987 -53.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36225",
    "data-name": "Path 36225",
    d: "M71,81.7h2.7v1.034H71Z",
    transform: "translate(-51.987 -60.507)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconDashboard);
export default __webpack_public_path__ + "static/media/Menu_Icon_Dashboard.2ca6206d.svg";
export { ForwardRef as ReactComponent };